class OffersHelper {
  getOrangeStatuses () {
    return ['vesting', 'pending_notification', 'notification_sent', 'notification_approved', 'pending_admin']
  }

  getRedStatuses () {
    return ['canceled', 'irrelevant']
  }

  getGreenStatuses () {
    return ['paid']
  }

  getStatuses () {
    return this.getOrangeStatuses().concat(this.getRedStatuses()).concat(this.getGreenStatuses())
  }

  getFiltersOptions () {
    const options = []
    const statuses = this.getStatuses()
    let color = ''
    for (let i = 0; i < statuses.length; i++) {
      const status = statuses[i]
      if (this.getRedStatuses().includes(status)) {
        color = '🔴'
      }
      if (this.getGreenStatuses().includes(status)) {
        color = '🍏'
      }
      if (this.getOrangeStatuses().includes(status)) {
        color = '🍊'
      }
      options.push({
        text: color + ' ' + status,
        value: status
      })
    }
    return options
  }

  getPayment (offer, plusVat = true) {
    if (offer === undefined) {
      return 0
    }
    let payment = offer.salary * (offer.percentage / 100)
    if (plusVat) {
      payment *= 1.18
    }
    return Math.round(payment)
  }

  getLastDocumentDate (offer) {
    if (offer === undefined) {
      return ''
    }
    const relevantDates = [...this.getRelevantDates()].map(date => offer[date])
    const sortedDates = relevantDates.sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
    return sortedDates[0]
  }

  getRelevantDates () {
    return ['invoice_date', 'payment_date', 'payment_request_date', 'reminded_at']
  }
}

export default OffersHelper
